export default __webpack_public_path__ + "static/media/horizontal-ellipsis.2140a925.svg";